module.exports = __webpack_public_path__ + "img/menuimg8.f4ec21f1.png";